/**
 * Race a server-action promise against a timeout so flaky mobile networks can
 * never leave a spinner stuck forever. Rejects with `timeoutMessage` when the
 * deadline passes first.
 */
export class ActionTimeoutError extends Error {
  constructor(
    message: string,
    readonly timeoutMs: number,
  ) {
    super(message);
    this.name = "ActionTimeoutError";
  }
}

export function withActionTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  timeoutMessage: string,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      // This stops waiting on the client; it does not cancel or roll back the
      // server action. In particular, a booking/payment outcome remains unknown.
      reject(new ActionTimeoutError(timeoutMessage, timeoutMs));
    }, timeoutMs);
    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
}
